export default __webpack_public_path__ + "media/images/rabbit_ui_conversation-00aafad051e4efe495c4a9f39fa44dfd.png";